import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPutEdc_sharing_groupIdEfficiency_settings = z.any()
export type TagsPutEdc_sharing_groupIdEfficiency_settings = z.infer<typeof tagsPutEdc_sharing_groupIdEfficiency_settings>

export const paramsPutEdc_sharing_groupIdEfficiency_settings = z.object({ "groupId": z.string() })
export type ParamsPutEdc_sharing_groupIdEfficiency_settings = z.infer<typeof paramsPutEdc_sharing_groupIdEfficiency_settings>

export const bodyPutEdc_sharing_groupIdEfficiency_settings = z.object({ "thresholdPercent": z.number().gte(0).lte(100), "startHour": z.number().int().gte(0).lte(23), "endHour": z.number().int().gte(1).lte(24), "maxExportKw": z.number().gte(0).lte(1000000).optional() })
export type BodyPutEdc_sharing_groupIdEfficiency_settings = z.infer<typeof bodyPutEdc_sharing_groupIdEfficiency_settings>

export const responsePutEdc_sharing_groupIdEfficiency_settings = z.object({ "payload": z.object({ "thresholdPercent": z.number().gte(0).lte(100), "startHour": z.number().int().gte(0).lte(23), "endHour": z.number().int().gte(1).lte(24), "maxExportKw": z.number().gte(0).lte(1000000).optional() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePutEdc_sharing_groupIdEfficiency_settings = z.infer<typeof responsePutEdc_sharing_groupIdEfficiency_settings>

interface IPutEdc_sharing_groupIdEfficiency_settings extends BaseMethodType {
  tags: TagsPutEdc_sharing_groupIdEfficiency_settings,
  params: ParamsPutEdc_sharing_groupIdEfficiency_settings,
  body: BodyPutEdc_sharing_groupIdEfficiency_settings,
  response: ResponsePutEdc_sharing_groupIdEfficiency_settings
}
export const URL = '/edc-sharing/:groupId/efficiency-settings'
export const validation = {
  put: {
    tags: tagsPutEdc_sharing_groupIdEfficiency_settings,
    params: paramsPutEdc_sharing_groupIdEfficiency_settings,
    body: bodyPutEdc_sharing_groupIdEfficiency_settings,
    response: responsePutEdc_sharing_groupIdEfficiency_settings
  }
}
export interface Edc_sharing_groupIdEfficiency_settings extends BaseRouteType {
  put: IPutEdc_sharing_groupIdEfficiency_settings
}